if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.productInfo = this.closest("product-info");
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        this.mql2 = window.matchMedia("(max-width: 767px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500),
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener("click", (event) => {
                this.handleStampZone(event.currentTarget.dataset.zoneType);
                this.setActiveMedia(mediaToSwitch.dataset.target, false);
              });
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }
      get isMobile() {
        return this.mql2.matches;
      }

      connectedCallback() {
        document.addEventListener("wiq-stamp-change", (event) => {
          if (this.isMobile) {
            this.stampChange({ detail: { type: event.detail.type } });
          }
          this.updateStampZone(event.detail.type);
        });
        this.updateStampZone("interior");

        if (this.isMobile) {
          setTimeout(() => {
            this.stampChange({ detail: { type: "interior" } });
          }, 100);
        }
      }

      stampChange(event) {
        if (event.detail.type == "interior") {
          const nextPosition =
            this.productInfo.getSelectedVariant(this.productInfo).featured_media
              .position + 1;
          const slide = this.elements.viewer.querySelector(
            `li[data-media-position="${nextPosition}"]`,
          );
          if (!slide) return;

          const mediaId = slide.getAttribute("data-media-id");
          if (mediaId) this.setActiveMedia(mediaId, false);
        } else {
          const mediaId = this.productInfo.getSelectedVariant(this.productInfo)
            ?.featured_media?.id;

          if (mediaId)
            this.setActiveMedia(
              `${this.productInfo.dataset.section}-${mediaId}`,
              false,
            );
        }
      }

      handleStampZone(stampZone) {
        document.dispatchEvent(
          new CustomEvent("wiq-stamp-change-inward", {
            detail: { type: stampZone },
          }),
        );
        this.updateStampZone(stampZone);
      }
      updateStampZone(stampZone) {
        document.body.setAttribute("data-wiq-slide-view", stampZone);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");
        if (!activeMedia) {
          return;
        }
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia?.classList?.add("is-active");

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`,
            );
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: "smooth" });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`,
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition,
        );
      }
      get isMobile() {
        return this.mql2.matches;
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img",
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position,
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation"),
        );
      }
    },
  );
}

class PiGallerySliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("pi-gallery-slider-component", PiGallerySliderComponent);

// Initials validation: defined once, reused on every input
const INITIALS_RULES = Object.freeze({
  maxLength: 8,
  maxLetters: 3,
  maxAmpersand: 1,
  maxSymbols: 1,
  specialSymbols: "!#$%()*+=?&",
});
const INITIALS_LETTER_REGEX = /[A-Za-z]/;
// Date input: digits only, auto-insert dots for XX.XX or XX.XX.XX (max 6 digits)
const DATE_INPUT_MAX_DIGITS = 6;

function filterInitialsValue(raw) {
  const { maxLength, maxLetters, maxAmpersand, maxSymbols, specialSymbols } =
    INITIALS_RULES;
  let letters = 0;
  let ampersands = 0;
  let specialCount = 0;
  const out = [];

  for (let i = 0; i < raw.length && out.length < maxLength; i++) {
    const ch = raw[i];

    if (INITIALS_LETTER_REGEX.test(ch)) {
      if (letters >= maxLetters) continue;
      letters++;
      out.push(ch.toUpperCase());
    } else if (ch === "&") {
      if (ampersands >= maxAmpersand) continue;
      ampersands++;
      out.push(ch);
    } else if (ch === "." || ch === "-") {
      out.push(ch);
    } else if (specialSymbols.includes(ch)) {
      if (specialCount >= maxSymbols) continue;
      specialCount++;
      out.push(ch);
    }
  }

  return out.join("");
}

function formatDateInput(value) {
  const digits = value.replace(/\D/g, "").slice(0, DATE_INPUT_MAX_DIGITS);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4, 6)}`;
}

function removeOneSpecialSymbol(str) {
  const { specialSymbols } = INITIALS_RULES;
  for (let i = 0; i < str.length; i++) {
    if (specialSymbols.includes(str[i])) {
      return str.slice(0, i) + str.slice(i + 1);
    }
  }
  return str;
}

class WiqCustomizerOptions extends HTMLElement {
  constructor() {
    super();
    this.element = {
      markingType: Array.from(this.querySelectorAll("[data-marking-type]")),
      initialsInput: this.querySelector("[data-initials-input]"),
      markingSymbolInputs: Array.from(
        this.querySelectorAll("[data-marking-symbol-input]"),
      ),
      dateInput: this.querySelector("[data-date-input]"),
      typographyStampZoneInputs: Array.from(
        this.querySelectorAll("[data-typography-stamp-zone]"),
      ),
      typographyFontInputs: Array.from(
        this.querySelectorAll("[data-typography-font]"),
      ),
      typographySizeInputs: Array.from(
        this.querySelectorAll("[data-typography-size]"),
      ),
      typographyColorInputs: Array.from(
        this.querySelectorAll("[data-typography-color]"),
      ),
    };
    this.data = {};
    this.data.markingType = this.querySelector(
      "[data-marking-type]:checked",
    )?.value;
  }
  connectedCallback() {
    this.element.markingType.forEach((element) => {
      element.addEventListener("change", this.onMarkingTypeChange.bind(this));
    });
    this.element.initialsInput.addEventListener(
      "input",
      this.onInitialsInputChange.bind(this),
    );
    this.element.markingSymbolInputs.forEach((element) => {
      element.addEventListener(
        "change",
        this.onMarkingSymbolInputChange.bind(this),
      );
    });
    // Toggle-off: clicking active symbol label deselects it
    this.element.symbolFieldset = this.querySelector(
      ".pi-product-customizer-options__symbols",
    );
    this.element.symbolPreview = this.querySelector("[data-symbol-preview]");
    this.querySelectorAll(
      ".pi-product-customizer-options__symbol-button",
    ).forEach((label) => {
      label.addEventListener("click", this.onSymbolLabelClick.bind(this));
    });
    this.updateSymbolFieldsetState();
    this.element.dateInput.addEventListener(
      "input",
      this.onDateInputChange.bind(this),
    );
    this.element.typographyStampZoneInputs.forEach((element) => {
      element.addEventListener(
        "change",
        this.onTypographyChoiceChange.bind(this),
      );
    });
    this.element.typographyFontInputs.forEach((element) => {
      element.addEventListener(
        "change",
        this.onTypographyChoiceChange.bind(this),
      );
    });
    this.element.typographySizeInputs.forEach((element) => {
      element.addEventListener(
        "change",
        this.onTypographyChoiceChange.bind(this),
      );
    });
    this.element.typographyColorInputs.forEach((element) => {
      element.addEventListener(
        "change",
        this.onTypographyChoiceChange.bind(this),
      );
    });

    document.addEventListener("wiq-stamp-change-inward", (event) => {
      const type = event.detail.type;
      var input = null;
      if (type) {
        input = this.element.typographyStampZoneInputs.find(
          (el) => el.value === type,
        );
      } else {
        input = this.element.typographyStampZoneInputs.find((el) => el.checked);
      }

      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event("change"));
      }
    });
  }
  onMarkingTypeChange(event) {
    event.preventDefault();
    this.markingType = event.target.value;
    if (this.markingType === "initials") {
      this.element.initialsInput.removeAttribute("disabled");
      this.element.markingSymbolInputs.forEach((element) => {
        element.removeAttribute("disabled");
      });
      this.element.dateInput.setAttribute("disabled", "");
    } else {
      this.element.dateInput.removeAttribute("disabled");
      this.element.initialsInput.setAttribute("disabled", "");
      this.element.markingSymbolInputs.forEach((element) => {
        element.setAttribute("disabled", "");
      });
    }
    this.updateData();
  }
  onInitialsInputChange(event) {
    const input = event.target;
    const raw = input.value;
    const valid = filterInitialsValue(raw);

    if (valid !== raw) {
      const start = input.selectionStart ?? valid.length;
      input.value = valid;
      input.setSelectionRange(
        Math.min(start, valid.length),
        Math.min(start, valid.length),
      );
    }

    // If initials no longer contain a special symbol, select "None" (first symbol radio)
    if (removeOneSpecialSymbol(valid) === valid) {
      const noneRadio = Array.from(this.element.markingSymbolInputs).find(
        (el) => el.value === "",
      );
      if (noneRadio) {
        noneRadio.checked = true;
        this.markingSymbol = "";
        this.updateSymbolFieldsetState();
      }
    }

    this.updateData();
  }
  onSymbolLabelClick(event) {
    const label = event.currentTarget;
    const inputId = label.getAttribute("for");
    if (!inputId) return;
    const input = this.querySelector("#" + inputId);
    if (!input || !input.checked) return;
    // Already checked — toggle it off (select "None")
    event.preventDefault();
    const noneRadio = this.element.markingSymbolInputs.find(
      (el) => el.value === "",
    );
    if (noneRadio) {
      noneRadio.checked = true;
      // Remove symbol from initials
      if (this.element.initialsInput) {
        let current = this.element.initialsInput.value;
        current = removeOneSpecialSymbol(current);
        this.element.initialsInput.value = filterInitialsValue(current);
      }
      this.updateSymbolFieldsetState();
      this.updateData();
    }
  }
  updateSymbolFieldsetState() {
    if (!this.element.symbolFieldset) return;
    const checked = this.element.markingSymbolInputs.find((el) => el.checked);
    const hasSymbol = checked && checked.value !== "";
    if (hasSymbol) {
      this.element.symbolFieldset.classList.add("has-active-symbol");
    } else {
      this.element.symbolFieldset.classList.remove("has-active-symbol");
    }
    // Update the symbol preview in the accordion header
    this.updateSymbolPreview();
  }
  onMarkingSymbolInputChange(event) {
    event.preventDefault();
    if (!this.element.initialsInput) return;

    let current = this.element.initialsInput.value;
    current = removeOneSpecialSymbol(current);

    const symbolValue = event.target.getAttribute("data-value");
    if (symbolValue) {
      current += symbolValue;
    }

    const valid = filterInitialsValue(current);
    this.element.initialsInput.value = valid;
    this.updateSymbolFieldsetState();
    this.updateData();
  }
  onDateInputChange(event) {
    const input = event.target;
    const raw = input.value;
    const formatted = formatDateInput(raw);

    if (formatted !== raw) {
      const cursor = input.selectionStart ?? formatted.length;
      input.value = formatted;
      const newCursor = Math.max(cursor, formatted.length);
      input.setSelectionRange(newCursor, newCursor);
    }

    this.updateData();
  }

  onTypographyChoiceChange(event) {
    event.preventDefault();
    const type = event.currentTarget;
    if (type.hasAttribute("data-typography-stamp-zone")) {
      document.dispatchEvent(
        new CustomEvent("wiq-stamp-change", { detail: { type: type.value } }),
      );
    }
    if (type.hasAttribute("data-typography-font")) {
      // Set CSS variable for font
      this.style.setProperty(
        "--wiq-font-family",
        type.getAttribute("data-typography-font"),
      );
    }

    this.updateData();
  }

  getData() {
    this.data.initials = this.element.initialsInput.value;
    this.data.markingSymbol = this.element.markingSymbolInputs.find(
      (el) => el.checked,
    )?.value;
    this.data.date = this.element.dateInput.value;
    this.data.markingType = this.element.markingType.find(
      (el) => el.checked,
    )?.value;
    this.data.typographyStampZone = this.element.typographyStampZoneInputs.find(
      (el) => el.checked,
    )?.value;
    this.data.typographyFont = this.element.typographyFontInputs
      .find((el) => el.checked)
      ?.getAttribute("data-typography-font");
    this.data.typographySize = this.element.typographySizeInputs.find(
      (el) => el.checked,
    )?.value;
    this.data.typographyColor = this.element.typographyColorInputs.find(
      (el) => el.checked,
    )?.value;

    return this.data;
  }

  updateSymbolPreview() {
    if (!this.element.symbolPreview) return;

    // Determine active marking type
    const activeType = this.element.markingType.find((el) => el.checked);
    const type = activeType ? activeType.value : "initials";

    let preview = "";
    if (type === "date") {
      preview = this.element.dateInput ? this.element.dateInput.value : "";
    } else {
      // Initials value already contains the symbol character, so just show it as-is
      preview = this.element.initialsInput
        ? this.element.initialsInput.value
        : "";
    }

    this.element.symbolPreview.textContent = preview;
  }

  updateData() {
    this.data = this.getData();
    console.log(this.data);
    this.updateSymbolPreview();
    document.dispatchEvent(
      new CustomEvent("wiq-render", { detail: this.data }),
    );
  }
}

customElements.define("wiq-customizer-options", WiqCustomizerOptions);

class WiqCanvas extends HTMLElement {
  constructor() {
    super();
    this.imageUrl = this.dataset.imageUrl;
    this.image = this.querySelector("img");
    this.konvaContainer = this.querySelector(".wiq-konva-container");
    this.loadedImage = null;
    this.resizeObserver = null;
    this.isInterior =
      this.closest("li")?.hasAttribute("data-is-interior") || false;
    this.stage = null;
    this.imageLayer = null;
    this.textLayer = null;
    this.konvaImage = null;
    this.stageWidth = 0;
    this.stageHeight = 0;
    this._boundOnWiqRender = this.onWiqRender.bind(this);
    this.productInfo = this.closest("product-info");
  }

  connectedCallback() {
    this.setPositionsData();
    if (!this.konvaContainer || typeof Konva === "undefined") return;
    const src = this.imageUrl || (this.image && this.image.src);
    if (!src) return;
    if (this.image) this.image.setAttribute("hidden", "");

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      this.loadedImage = img;
      this.syncStageSize();
      this.observeSize();
    };
    img.onerror = () => {};
    img.src = src;
    document.addEventListener("wiq-render", this._boundOnWiqRender);
  }

  setPositionsData() {
    this.positionsData = JSON.parse(
      this.productInfo.dataset.positions ||
        '{"interior":{"alignHorizontal":"center","alignVertical":"middle","x":0.5,"y":0.5},"exterior":{"alignHorizontal":"center","alignVertical":"middle","x":0.5,"y":0.5}}',
    );
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    document.removeEventListener("wiq-render", this._boundOnWiqRender);
    if (this.stage) {
      this.stage.destroy();
      this.stage = null;
      this.imageLayer = null;
      this.textLayer = null;
      this.konvaImage = null;
    }
  }

  /** Pixel ratio so the canvas has extra pixels and stays crisp when the browser zooms. */
  getPixelRatio() {
    return 3;
  }

  getStageSize() {
    const rect = this.konvaContainer.getBoundingClientRect();
    return {
      w: Math.round(rect.width),
      h: Math.round(rect.height),
    };
  }

  observeSize() {
    if (!this.konvaContainer || !this.loadedImage) return;
    this.resizeObserver = new ResizeObserver(() => this.syncStageSize());
    this.resizeObserver.observe(this.konvaContainer);
  }

  syncStageSize() {
    if (!this.loadedImage || !this.konvaContainer) return;

    const { w, h } = this.getStageSize();
    if (w <= 0 || h <= 0) return;
    const scale = this.getPixelRatio();
    if (this.stage) {
      this.stageWidth = w;
      this.stageHeight = h;
      this.stage.width(w * scale);
      this.stage.height(h * scale);
      this.stage.scale({ x: scale, y: scale });
      if (this.konvaImage) {
        this.konvaImage.width(w);
        this.konvaImage.height(h);
      }
      this.imageLayer.batchDraw();
      this.updateTextOnly();
      return;
    }
    this.initKonvaStage(w, h);
  }

  initKonvaStage(w, h) {
    if (!this.loadedImage || !this.konvaContainer) return;
    this.stageWidth = w;
    this.stageHeight = h;
    const scale = this.getPixelRatio();
    this.stage = new Konva.Stage({
      container: this.konvaContainer,
      width: w * scale,
      height: h * scale,
      listening: false,
    });
    this.stage.scale({ x: scale, y: scale });
    this.imageLayer = new Konva.Layer({ listening: false });
    this.textLayer = new Konva.Layer({ listening: false });
    this.stage.add(this.imageLayer);
    this.stage.add(this.textLayer);
    this.konvaImage = new Konva.Image({
      image: this.loadedImage,
      x: 0,
      y: 0,
      width: w,
      height: h,
      listening: false,
    });
    this.imageLayer.add(this.konvaImage);
    this.imageLayer.batchDraw();
    const customizer = document.querySelector(
      "product-info wiq-customizer-options",
    );
    if (customizer) {
      this.data = customizer.getData();
      this.updateTextOnly();
    }
  }

  onWiqRender(event) {
    this.data = event.detail;
    if (this.data.positions) {
      this.positionsData = this.data.positions;
    }
    this.updateTextOnly();
  }

  /** True if the selected zone matches this canvas (exterior canvas for Exterior, interior for Interior). */
  isCanvasForSelectedZone() {
    if (!this.data) return false;
    const zone = (this.data.typographyStampZone || "").toLowerCase();
    return (
      (this.isInterior && zone === "interior") ||
      (!this.isInterior && zone === "exterior")
    );
  }

  getTextPosition(w, h) {
    const zone = this.isInterior
      ? this.positionsData.interior
      : this.positionsData.exterior;
    if (!zone) return { x: 0, y: 0, align: "center", verticalAlign: "middle" };
    return {
      x: w * (typeof zone.x === "number" ? zone.x : 0),
      y: h * (typeof zone.y === "number" ? zone.y : 0),
      align:
        zone.alignHorizontal === "left" || zone.alignHorizontal === "right"
          ? zone.alignHorizontal
          : "center",
      verticalAlign:
        zone.alignVertical === "top" || zone.alignVertical === "bottom"
          ? zone.alignVertical
          : "middle",
    };
  }

  /**
   * Offset for Konva.Text so (x,y) is the anchor point per alignment.
   * Konva: offset shifts the origin; offsetX=width/2, offsetY=height/2 puts center at (x,y).
   */
  getTextOffsetForAlignment(align, verticalAlign, textWidth, textHeight) {
    const offsetX =
      align === "right" ? textWidth : align === "center" ? textWidth / 2 : 0;
    const offsetY =
      verticalAlign === "bottom"
        ? textHeight
        : verticalAlign === "middle"
          ? textHeight / 2
          : 0;
    return { offsetX, offsetY };
  }

  /**
   * Luminance (0–255) for contrast; values under ~128 are dark.
   * @param {{ r: number, g: number, b: number }} c
   * @returns {number}
   */
  getLuminance(c) {
    if (!c) return 128;
    return 0.299 * c.r + 0.587 * c.g + 0.114 * c.b;
  }

  /**
   * Get the average color near the position (samples a few pixels around the point).
   * Useful for contrast, shadow color, or stamped effect. Returns null if unavailable (e.g. CORS).
   * @param {number} [sampleRadius=2] - Half-size of sample region (e.g. 2 = 5x5 pixels). Use 0 for single pixel.
   * @returns {{ r: number, g: number, b: number, a: number } | null}
   */
  getTheColor(pos, sampleRadius = 2) {
    if (!this.loadedImage) return null;
    const img = this.loadedImage;
    const imgW = img.naturalWidth || img.width;
    const imgH = img.naturalHeight || img.height;
    if (imgW <= 0 || imgH <= 0) return null;

    try {
      const scaleX = imgW / this.stageWidth;
      const scaleY = imgH / this.stageHeight;
      const cx = Math.floor(pos.x * scaleX);
      const cy = Math.floor(pos.y * scaleY);
      const r = Math.max(
        0,
        Math.floor(sampleRadius * Math.min(scaleX, scaleY)),
      );
      const x0 = Math.max(0, cx - r);
      const y0 = Math.max(0, cy - r);
      const x1 = Math.min(imgW, cx + r + 1);
      const y1 = Math.min(imgH, cy + r + 1);
      const sw = x1 - x0;
      const sh = y1 - y0;
      if (sw <= 0 || sh <= 0) return null;

      if (!this._colorCanvas) {
        this._colorCanvas = document.createElement("canvas");
        this._colorCtx = this._colorCanvas.getContext("2d", {
          willReadFrequently: true,
        });
      }
      this._colorCanvas.width = sw;
      this._colorCanvas.height = sh;
      this._colorCtx.drawImage(img, x0, y0, sw, sh, 0, 0, sw, sh);
      const d = this._colorCtx.getImageData(0, 0, sw, sh).data;

      let sumR = 0,
        sumG = 0,
        sumB = 0,
        sumA = 0,
        n = 0;
      for (let i = 0; i < d.length; i += 4) {
        sumR += d[i];
        sumG += d[i + 1];
        sumB += d[i + 2];
        sumA += d[i + 3];
        n++;
      }
      if (n === 0) return null;
      return {
        r: Math.round(sumR / n),
        g: Math.round(sumG / n),
        b: Math.round(sumB / n),
        a: sumA / n / 255,
      };
    } catch (_) {
      return null;
    }
  }

  get isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  updateTextOnly() {
    if (!this.textLayer || !this.data) return;
    const w = this.stageWidth;
    const h = this.stageHeight;
    if (w <= 0 || h <= 0) return;
    this.textLayer.destroyChildren();

    const isForZone = this.isCanvasForSelectedZone();
    if (!isForZone) {
      this.textLayer.batchDraw();
      return;
    }
    const text = this.getDisplayText();
    if (!text) {
      this.textLayer.batchDraw();
      return;
    }

    const fontFamily = this.data.typographyFont || "sans-serif";
    const fontSize = this.getTypographyFontSize();
    var fill = this.getTypographyFillStyle();
    const pos = this.getTextPosition(w, h);
    const color = this.getTheColor(pos, 20);
    const luminance = this.getLuminance(color);
    const isDarkBg = luminance < 55;
    const isToneOnTone = fill === "rgba(120,100,90,0.85)";
    if (isToneOnTone && color) {
      if (isDarkBg) {
        //   const t = 0.35;
        //   const r = Math.round(color.r + (255 - color.r) * t);
        //   const g = Math.round(color.g + (255 - color.g) * t);
        //   const b = Math.round(color.b + (255 - color.b) * t);
        //   fill = `rgba(${r},${g},${b},0.75)`;
        // } else {
        //   fill = `rgba(${color.r},${color.g},${color.b},${Math.max(color.a, 0.85)})`;
        // }
        fill = `rgba(${color.r},${color.g},${color.b},${Math.max(color.a, 0.85)})`;
      }
      fill = `rgba(${color.r},${color.g},${color.b},${Math.max(color.a, 0.85)})`;
    }

    // Leather-stamped emboss: two layers at same position, shadows in opposite directions
    const letterSp = 2;
    const sharedTextConfig = {
      x: pos.x,
      y: pos.y,
      text: text,
      fontSize: fontSize,
      fontFamily: fontFamily,
      letterSpacing: letterSp,
      fill: fill,
      align: pos.align,
      verticalAlign: pos.verticalAlign,
      listening: false,
      wrap: "none",
    };

    const highlightNode = new Konva.Text({
      ...sharedTextConfig,
      shadowColor: isDarkBg
        ? "rgba(255,255,255,0.22)"
        : "rgba(255,255,255,0.14)",
      shadowBlur: isDarkBg ? 0.3 : 0.3,
      shadowOffset: { x: 0.5, y: 0.6 },
      shadowOpacity: 1,
    });

    const textNode = new Konva.Text({
      ...sharedTextConfig,
      shadowColor: isDarkBg ? "rgba(0,0,0,0.65)" : "rgba(0,0,0,0.40)",
      shadowBlur: isDarkBg ? 0.5 : 0.4,
      shadowOffset: { x: -0.5, y: -0.6 },
      shadowOpacity: 1,
    });
    const tw = Math.max(1, textNode.width());
    const th = Math.max(1, textNode.height());

    const { offsetX, offsetY } = this.getTextOffsetForAlignment(
      pos.align,
      pos.verticalAlign,
      tw,
      th,
    );
    highlightNode.offsetX(offsetX);
    highlightNode.offsetY(offsetY);
    textNode.offsetX(offsetX);
    textNode.offsetY(offsetY);

    this.textLayer.add(highlightNode);
    this.textLayer.add(textNode);
    this.textLayer.batchDraw();
  }

  getDisplayText() {
    if (!this.data) return "";
    if (this.data.markingType === "date") {
      return (this.data.date || "").trim();
    }
    return (this.data.initials || "").trim();
  }

  getTypographyFontSize() {
    const size = this.data?.typographySize || "MM";
    const baseFontSize = size === "PM" ? 14 : 16;
    const desktopRefWidth = 711;
    const visibleWidth =
      this.konvaContainer?.getBoundingClientRect?.()?.width ??
      this.stageWidth ??
      0;

    const scale = visibleWidth > 0 ? visibleWidth / desktopRefWidth : 1;
    return Math.max(7, Math.round(baseFontSize * scale));
  }

  getTypographyFillStyle() {
    const color = this.data?.typographyColor || "Tone on tone";
    if (color === "Silver") return "#a6a9aa";
    if (color === "Gold") return "#c8b273";
    return "rgba(120,100,90,0.85)";
  }

  get canvasUrl() {
    return this.stage.toDataURL();
  }
}

customElements.define("wiq-canvas", WiqCanvas);
